<template>
	<div>
	
		<div id="pdf">
			 <v-file-input v-model='theFile' required :rules="[
        value => !!value  || 'Please Select a file']" @change='convertoBase64' label="Upload Pedigree to report"></v-file-input>
			<v-select @change='getContent' v-model='selectedContent' dense :items="items"
          label="Select Page to edit"
          outlined></v-select>
			 <vue-editor v-model="content" />

			<v-btn class='ma-2' color="primary" @click="saveContent">Save content</v-btn>

			<v-btn class='ma-2' color="info" @click="loading = true,pdfgen(false)">Preview report</v-btn>

			<v-btn class='ma-2' color="success" @click="loading = true,pdfgen(true)">Upload report</v-btn>

				
		</div>
	
	</div>
</template>

<script>
import htmlToPdfmake from "html-to-pdfmake";
import { VueEditor } from "vue2-editor";
import logobase64 from '../assets/logo64.js'
import { postReq } from '../helper/firestore'
import { mapFields } from 'vuex-map-fields';
export default {
	components: { VueEditor },
	props: {
		patientData: Object,

	},
	data() {
		return {
			items : [
				"Summary of Attached Medical Records",
				"Additional Notes"
			],
			selectedContent : null,
			content : "",
			theFile: null,
			base64 : null,
			//he,she
			genderThirdPerson: null,
			//Mr, Mrs
			genderTitle: null,
			//woman, men
			genderPerson: null
		}
	},
	computed: {
		...mapFields([
			'user',
			'snackBarshow',
			'snackBarType',
			'snackBarmessage',
			'overlay'
		]),
	},
	mounted(){
	},
	methods: {
		getContent(){
			switch(this.selectedContent){
				case "Summary of Attached Medical Records" : 
				this.content = this.patientData.report.SummaryofattachedRecord ? this.patientData.report.SummaryofattachedRecord : "<p><strong>Consult Notes: </strong></p><p><br></p><p><strong>Pathology Reports:</strong></p><p><br></p><p><strong>Genetic Testing:</strong></p><p><br></p><p><strong>[LIST OUT SPECIFIC PATH REPORTS, GENETIC COUNSELING NOTES, GENETIC TEST REPORTS, ETC]</strong></p>";
				break;
				case "Additional Notes" : 
				this.content = this.patientData.report.AdditonalNotes ? this.patientData.report.AdditonalNotes : "<p>Based on the family history of [SPECIFIC CONDITION] genetic counseling was recommended for Ms/Mr. ****. At the time of the writing of this report, this had not yet been pursued. </p><p><br></p><p>Based on the family history of [SPECIFIC CONDITION], it is likely that there is an increased familial risk, but currently no genetic testing is indicated for [SPECIFIC CONDITION], and genetic counseling is not recommended at this time. </p><p><br></p><p>We were unable to clarify the specifc diagnosis of *** in [SPECIFY RELATIVE]. </p><p><br></p><p>We were unable to obtain *** medical records. Ms/Mr. understands that the report may be amended with additional information in the health or family history as it becomes available. </p><p><br></p><p>We can be reached at 844 743 6384 extension ***. </p><p><br></p><p>Genetic Support Foundation 844 743 6384 extension 900&nbsp;</p>";
				break;
			}
		},
		saveContent(){

				switch(this.selectedContent){
				case "Summary of Attached Medical Records" : 
				this.patientData.report.SummaryofattachedRecord = this.content;
				break;
				case "Additional Notes" : 
				this.patientData.report.AdditonalNotes = this.content;
				break;
			}

					postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/patients/saveReport', {
						uid: this.patientData.uid,
						report : this.patientData.report
					}, () => {
						this.snackBarType = "success"
						this.snackBarshow = true
						this.snackBarmessage = "Report Updated"
						this.commentDialog = false
					})
		},
			pedigree(){
				if(this.theFile){
					return{
						
						image: "data:image/png;base64, " + this.base64,
						fit: [530, 800]
						}
				}else{
					return null;
				}
				
			},
		  convertoBase64(f){
             if (f === null){return;}
          var reader = new FileReader();
          reader.onload = ((theFile) => {
            this.theFile = theFile;
            return (e) => {
              var binaryData = e.target.result;
			  this.base64 = window.btoa(binaryData);
            };
          })(f);
          reader.readAsBinaryString(f);
      },
		generateDnaPage() {
			if (this.user.plan !== "p1") {
				return []
			} else {
				return [
					{ pageBreak: 'before', canvas: [{ type: 'rect', color: '#399342', x: -40, y: -40, w: 800, h: 60 }] },
					{ text: 'DNA Banking', fontSize: 24, color: 'white', bold: true, margin: [0, -40, 0, 8] },
					{ style: 'body', text: "DNA Banking:", bold: true },
					{ margin: [0, -40, 0, 8], text: this.patientData.familyHistory[0].name + " submitted a blood sample for DNA Banking which was sent to the laboratory Prevention Genetics/Seattle Children’s Hospital. The sample was submitted on [DATE].  The depositor number assigned is:  [DEPOSITOR  NUMBER].  " },
					{ margin: [0, 0, 0, 8], text: "[NAME OF RELATIVE(S)] was/were named as the representatives with access to the banked DNA.  " },
				]
			}

		},
		formatAddress(address){
			return address.street + " " + address.city + " " + address.state + " " + address.zip
		},
		convertPedgireeJSdata(family) {
			let result = [];
			family.forEach(element => {
				if (element.relationship === "self") {
					result.push({ "name": element.pid, "sex": "M", "display_name": element.name, "top_level": false, "proband": true })
				} else if (element.relationship === "mom") {
					result[0].mother = element.pid
					result.push({ "name": element.pid, "sex": "F", "display_name": element.name, "top_level": true, })
				} else if (element.relationship === "dad") {
					result[0].father = element.pid
					result.push({ "name": element.pid, "sex": "M", "display_name": element.name, "top_level": true, })
				}

			});

			return result;
		},
		familyHistCondition(conditions) {
			if (conditions.length === 0) {
				return {}
			}
			var result = [
				['Name', 'Type', 'Dx Age']
			]
			conditions.forEach(condition => {
				result.push([condition.name, condition.type, condition.age])
			})
			return {
				table: {
					body: result
				},
			}
		},
		familyHistoryFormatName(person){
			if(person.death === "" || !person.death){
				return person.name;
				
			}else{
				return person.name + "(deceased at "+person.death+")"
			}
		},
		familyHis(familyHistory) {
			let result = [
				['Name', 'Relationship to you', 'Age', 'Conditions']
			]
			let temp = (this.customSortFunction(familyHistory));
			temp.forEach(element => {
				result.push([this.familyHistoryFormatName(element), element.relationship, this.patientage(element.dob), this.familyHistCondition(element.conditions)])
				
			});
			return result
		},
		customSortFunction(familyHistory){
			let child = familyHistory.filter(f => f.relationship === "child");
			let grandchild = familyHistory.filter(f => f.relationship === "grandchild");
			let sibling = familyHistory.filter(f => f.relationship === "sibling");
			let niece= familyHistory.filter(f => f.relationship === "niece");
			let nephew = familyHistory.filter(f => f.relationship === "nephew");
			let father = familyHistory.filter(f => f.relationship === "father");
			let mother = familyHistory.filter(f => f.relationship === "mother");
			let maternalUncle = familyHistory.filter(f => f.relationship === "maternal uncle");
			let maternalAunt = familyHistory.filter(f => f.relationship === "maternal aunt");
			let maternalCousins = familyHistory.filter(f => f.relationship === "maternal cousin");
			let maternalGrandfather = familyHistory.filter(f => f.relationship === "maternal grandfather");
			let maternalGrandmother = familyHistory.filter(f => f.relationship === "maternal grandmother");
			let paternalUncle = familyHistory.filter(f => f.relationship === "paternal uncle");
			let paternalAunt = familyHistory.filter(f => f.relationship === "paternal aunt");
			let paternalCousins = familyHistory.filter(f => f.relationship === "paternal cousin");
			let paternalGrandfather = familyHistory.filter(f => f.relationship === "paternal grandfather");
			let paternalGrandmother = familyHistory.filter(f => f.relationship === "paternal grandmother");
			return [...child,...grandchild,...sibling,...niece,...nephew,...father,...mother,...maternalUncle,...maternalAunt,...maternalCousins,...maternalGrandfather,...maternalGrandmother,...paternalUncle,...paternalAunt,...paternalCousins,...paternalGrandfather,...paternalGrandmother]

		},
		condition(conditions) {
			if (conditions.length === 0) {
				return [
					[]
				];
			}
			let result = [
				['Category of diagnosis', 'Type of diagnosis', 'Age diagnosed', 'Details']
			]
			conditions.forEach(element => {
				result.push([element.name, element.type, element.age, element.details])
			});
			return result
		},
		surgicalHistory(history) {
			if (history.length === 0) {
				return [
					[]
				];
			}
			let result = [
				['Name of surgery', 'surgery date', 'Details']
			]
			history.forEach(element => {
				result.push([element.name, element.date, element.details])
			});
			return result
		},
		exposures(exposures) {
			if (exposures.length === 0) {
				return [
					[]
				];
			}
			let result = [
				['Name', 'use per week', 'Details']
			]
			exposures.forEach(element => {
				result.push([element.name, element.usePerWeek, element.details])
			});
			return result
		},
		beneficiaries(beneficiaries) {

			return beneficiaries.map(b => {
				return {
					margin: [0, 10, 0, 15],
					text: `Name: ${b.name}  \n Email: ${b.email} \n Phone: ${b.phone} \n Relation: ${b.relation}`
				}
			})
		},
		calculateRelationship(familyData, relation) {
			let children = familyData.filter(person => person.relationship === relation)
			return children.length;
		},
		patientGender(gender) {
			switch (gender) {
				case "Male":
					this.genderPerson = "man"
					this.genderThirdPerson = "He"
					this.genderTitle = "Mr."
					return
				case "Female":
					this.genderPerson = "woman"
					this.genderThirdPerson = "She"
					this.genderTitle = "Mrs."
					return
				default:
					this.genderPerson = "unknown gender"
					this.genderThirdPerson = "User"
					this.genderTitle = ""
					return
			}
		},
		patientage(dob) {
			if (!dob) {
				return 0
			}
			let age = this.$moment().diff(this.$moment(dob, 'YYYYMMDD'), 'years')
			return age;
		},
		pdfgen: function(isUpload) {
			//this.convertPedgireeJSdata(this.patientData.familyHistory)
			var pdfMake = require("pdfmake/build/pdfmake.js");
			if (pdfMake.vfs == undefined) {
				var pdfFonts = require("pdfmake/build/vfs_fonts.js");
				pdfMake.vfs = pdfFonts.pdfMake.vfs;
			}
			// this.patientData.familyHistory[0] is always patient's self
			this.patientGender(this.patientData.familyHistory[0].gender)
			var docDefinition = {
				footer: (currentPage) => {
					if (currentPage !== 1)
						return {
							stack: [
								{ text: 'Name: ' + this.patientData.familyHistory[0].name.toUpperCase() + ' | Date of Birth:' + this.patientData.familyHistory[0].dob ,fontSize: 12, margin: [50, 0, 0, 0] },
							]
						}
				},
				content: [{
						image: 'logo',
						width: 200
					},
					{
						stack: [
							'My Genetic Trust Report',
							{ canvas: [{ type: 'line', x1: 0, y1: 15, x2: 410, y2: 15, lineWidth: 1 }] },
							{ text: this.patientData.familyHistory[0].name, style: 'subheader' },
							{ text: "Date Report Generated: " + this.$moment().format("MM/DD/YYYY"), fontSize: 15 },
						],
						style: 'header'
					},
					//page 2
					{ pageBreak: 'before', canvas: [{ type: 'rect', color: '#399342', x: -40, y: -40, w: 800, h: 60 }] },
					{ text: 'Summary', fontSize: 24, color: 'white', bold: true, margin: [0, -40, 0, 8] },
					{ margin: [0, 40, 0, 15], text: "At the time this report was generated, " + this.genderTitle + " " + this.patientData.familyHistory[0].name + " was a " + this.patientage(this.patientData.familyHistory[0].dob) + " year-old " + this.genderPerson + ". " + this.genderThirdPerson + " has " + this.calculateRelationship(this.patientData.familyHistory, "child") + " children and " + this.calculateRelationship(this.patientData.familyHistory, "grandchild") + " grandchildren.  " + this.genderThirdPerson + " has named the following as beneficiaries that will have access to " + this.genderThirdPerson + " My Genetic Trust report." },

					this.beneficiaries(this.patientData.info.beneficiaries),

					//page 3
					{ pageBreak: 'before', canvas: [{ type: 'rect', color: '#399342', x: -40, y: -40, w: 800, h: 60 }] },
					{ text: 'Authorization', fontSize: 24, color: 'white', bold: true, margin: [0, -40, 0, 8] },
					{ style: 'body', text: "I, " + this.patientData.familyHistory[0].name + ", authorize Genetic Support Foundation to use or disclose all information contained in my My Genetic Trust." },
					{ margin: [0, -40, 0, 8], text: "Genetic Support Foundation may disclose this health information to the following recipients:" },
					{ margin: [0, 0, 0, 8], text: "Name: " + this.patientData.familyHistory[0].name },
					{ margin: [0, 0, 0, 8], text: "Address: " + this.formatAddress(this.patientData.info.address) },
					{ margin: [0, 0, 0, 8], text: "Phone: " + this.patientData.info.phone +  " Email : " + this.patientData.info.email },
					{ margin: [0, 50, 0, 8], bold: true, text: "Signature of Patient or Authorized Representative: _____________________________________" },
					{ margin: [0, 20, 0, 8], text: "Date: " + this.$moment().format("MM/DD/YYYY") },
					{ text: " Time: " + this.$moment().format("hh:mm a") },
					//page 4
					this.generateDnaPage(),
					//page 5
					{ pageBreak: 'before', canvas: [{ type: 'rect', color: '#399342', x: -40, y: -40, w: 800, h: 60 }] },
					{ text: 'Past Medical History', fontSize: 24, color: 'white', bold: true, margin: [0, -40, 0, 8] },
					{ margin: [0, 40, 0, 10], text: "Past Medical History:", bold: true },
					{
						margin: [0, 5, 0, 15],
						table: {
							body: this.condition(this.patientData.familyHistory[0].conditions)
						}
					},
					{ margin: [0, 40, 0, 10], text: "Past Surgical History: ", bold: true },
					{
						margin: [0, 5, 0, 15],
						table: {
							body: this.surgicalHistory(this.patientData.health.surgeries)
						}
					},
					{ margin: [0, 40, 0, 10], text: "Exposures:", bold: true },
					{
						margin: [0, 5, 0, 15],
						table: {
							body: this.exposures(this.patientData.health.exposures)
						}
					},
					//page 6
					{ pageBreak: 'before', canvas: [{ type: 'rect', color: '#399342', x: -40, y: -40, w: 800, h: 60 }] },
					{ text: 'Family History', fontSize: 24, color: 'white', bold: true, margin: [0, -40, 0, 8] },
					{ style: 'body', text: "We reviewed the family history and the following significant family health history was reported by " + this.patientData.familyHistory[0].name + " as outlined below.  Please see the attached family health tree. " },
					
					{
						margin: [0, 5, 0, 30],
						table: {
							body: this.familyHis(this.patientData.familyHistory)
						}
					},
					//page 7
					{ pageBreak: 'before', canvas: [{ type: 'rect', color: '#399342', x: -40, y: -40, w: 800, h: 60 }] },
					{ text: 'Family Health Tree', fontSize: 24, color: 'white', bold: true, margin: [0, -40, 0, 30] },
					this.pedigree(),
					//page 8
					{ pageBreak: 'before', canvas: [{ type: 'rect', color: '#399342', x: -40, y: -40, w: 800, h: 60 }] },
					{ text: 'Summary of Attached Medical Records', fontSize: 24, color: 'white', bold: true, margin: [0, -40, 0, 20] },
					htmlToPdfmake(this.patientData.report.SummaryofattachedRecord ? this.patientData.report.SummaryofattachedRecord : ""),
	
					//page 9
					{ pageBreak: 'before', canvas: [{ type: 'rect', color: '#399342', x: -40, y: -40, w: 800, h: 60 }] },
					{ text: 'Additional Notes', fontSize: 24, color: 'white', bold: true, margin: [0, -40, 0, 20] },
						htmlToPdfmake(this.patientData.report.AdditonalNotes ? this.patientData.report.AdditonalNotes : ""),

					//page 10
				],
				images: { logo: logobase64 },
				styles: {
					header: {
						fontSize: 35,
						color: '#399342',
						bold: true,
						alignment: 'left',
						margin: [0, 190, 0, 80]
					},
					subheader: {
						fontSize: 30,
						margin: [0, 20, 0, 80]
					},
					body: { margin: [0, 40, 0, 80] }
				}
			}
			if (isUpload) {
				const pdfDocGenerator = pdfMake.createPdf(docDefinition);
				pdfDocGenerator.getBase64((data) => {

					postReq(process.env.VUE_APP_ROOT_API_URL + 'api/message/uploadFile', {
						email: this.patientData.info.email,
						type: "report",
						userID: this.patientData.uid,
						baseString: data,
						selectedDocType: "report",
						fileType: "application/pdf",
						fileName: "report_" + this.$moment().format("MMDDYYYYHHMMSS")
					}, () => {
						this.snackBarType = "success"
						this.snackBarshow = true
						this.snackBarmessage = "Report Uploaded to User's folder"
						this.commentDialog = false
					})
				});
			} else {
				pdfMake.createPdf(docDefinition).download(this.formID + ".pdf", () => {});
			}

		}
	}
}
</script>

<style>

</style>